import { useEffect, useRef, useState } from 'react';
import { useBrandStore } from '../stores/brandStore';

// 统一加载效果：logo 底座（与 index.html 骨架屏同款，IotNobo 商标图片）。
// 首屏挂载时接管 index.html 的 #root-skeleton（DOM 不销毁 → 动画连续不重启，刷新无“两个加载页切换”感）；
// 接管不成功时（骨架屏已被消费/自定义文案场景）自渲染同款。
// H2：文案默认跟随品牌配置（白标 OEM）。
export default function AppLoading({
  text,
  sub = '数字孪生 · 可视化 · 智能运维',
  style,
}: {
  text?: string;
  sub?: string;
  style?: React.CSSProperties;
}) {
  const brandName = useBrandStore((s) => s.config?.name);
  const displayText = text ?? brandName ?? 'DTwince 云边智孪';
  const containerRef = useRef<HTMLDivElement>(null);
  const [adopted, setAdopted] = useState(false);

  useEffect(() => {
    const sk = document.getElementById('root-skeleton');
    if (sk) {
      if (containerRef.current) {
        containerRef.current.appendChild(sk);
        setAdopted(true);
      } else {
        sk.remove();
      }
    }
  }, []);

  // 卸载时确保骨架屏被清理（内容就绪后不留遮挡）
  useEffect(() => {
    return () => {
      const sk = document.getElementById('root-skeleton');
      if (sk) sk.remove();
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 100%)',
        ...style,
      }}
    >
      <style>{`@keyframes dtw-pulse{0%,100%{opacity:1}50%{opacity:.45}}`}</style>
      {!adopted && (
        <>
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 12,
              background: 'rgba(0,0,0,0.25)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              animation: 'dtw-pulse 1.2s ease-in-out infinite',
            }}
          >
            <img src="/favicon.ico" alt="IotNobo" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 12 }} />
          </div>
          <div
            style={{
              marginTop: 18,
              color: 'rgba(255,255,255,0.75)',
              fontSize: 18,
              letterSpacing: 2,
              animation: 'dtw-pulse 1.2s ease-in-out infinite 0.15s',
            }}
          >
            {displayText}
          </div>
          <div style={{ marginTop: 8, color: 'rgba(255,255,255,0.35)', fontSize: 12, letterSpacing: 4 }}>{sub}</div>
        </>
      )}
    </div>
  );
}